import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const KpiCard = styled.div`
	width: 100%;
	padding: 1em;
	margin: 0.5%;
	background-color: ${colors.white};
	box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
`;

export const CardValue = styled.div`
	display: block;
	font-size: 125%;
	font-weight: bolder;
`;

export const CardText = styled.div`
	display: block;
	font-size: 65%;
	padding-left: 0.2em;
`;
